import createGuest from 'cross-domain-storage/guest';

import amplitudeJS from 'amplitude-js';
import { isSignUp, isPaid, getReferrer } from './auth0';
import { isMobile, generateGUID } from '../core/utils';
import { thirdPartyCookiesEnabled } from './third-party-cookies';

const amplitude = amplitudeJS.getInstance();
const queryParams = new URLSearchParams(window.location.search);
const abexpid = queryParams.get('abexpid');
const planId = queryParams.get('pricing_plan_id') || queryParams.get('pricingPlanId') || null;

const EVENT_NAMES = {
  SWITCH_AUTH_MODE: 'Switch auth mode',
  AUTH: 'Authenticate',
  RESET_PASSWORD: 'Reset password',
  VIEW_JAAS: 'Go to JaaS from portal',
};

const PAGE_NAMES = {
  LOGIN_SIGNUP_PAGE: 'View login/signup page',
  PASSWORD: 'View password pane',
  PINCODE: 'View pincode page',
  RESET_PASSWORD: 'View reset password',
  MORE_PROVIDERS: 'View more providers popup',
  PORTAL: 'View JaaS portal',
  LEARN_MORE: 'View learn more page',
};

const DID_STORAGE_NAME = '__AMDID';

let sharedStorage;
let cookiesEnabled;

let currentAdName;

const getSharedStorage = async () => {
  if (sharedStorage) {
    return sharedStorage;
  }

  const url = SHARED_STORAGE_HOST;

  try {
    const isStorageAvailable = await fetch(url, {
      method: 'HEAD',
    });

    if (isStorageAvailable.ok) {
      sharedStorage = createGuest(url);
      return sharedStorage;
    }
  } catch (err) {
    throw new Error(err);
  }

  throw new Error('Failed to access shared storage');
};


const getDeviceID = async () => {
  let id;
  try {
    const storage = await getSharedStorage();
    id = await new Promise(resolve => {
      storage.get(DID_STORAGE_NAME, (error, data) => {
        if (data) {
          resolve(data);
          return;
        }
        resolve(null);
      });
    });

    storage.close();
  } catch (e) { } // eslint-disable-line
  return id;
}

const setDeviceID = async id => {
  try {
    const storage = await getSharedStorage();
    storage.set(DID_STORAGE_NAME, id, () => {
      storage.close();
    })
  } catch (e) { } // eslint-disable-line
}

export const initAnalytics = async deviceId => {
  cookiesEnabled = await thirdPartyCookiesEnabled();
  amplitude.init(AMPLITUDE_KEY, null, {
    includeReferrer: true,
    saveParamsReferrerOncePerSession: false,
  });

  if (!cookiesEnabled) {
    return;
  }

  if (deviceId && isMobile()) {
    amplitude.setDeviceId(deviceId);
  } else {
    let id = await getDeviceID();
    if (!id) {
      id = generateGUID();
      await setDeviceID(id);
    }
    amplitude.setDeviceId(id);
  }
}

export const setCurrentAdName = adName => {
    currentAdName = adName;
}

const trackEvent = (eventName, props) => amplitude.logEvent(eventName, {
  ...props,
  isSignUp: isSignUp(),
  adName: currentAdName,
  isPaid: isPaid(),
  referrer: getReferrer(),
  abexpid,
  planId,
});

const trackPageView = (pageName, props) => amplitude.logEvent(pageName, {
  ...props,
  isSignUp: isSignUp(),
  adName: currentAdName,
  isPaid: isPaid(),
  referrer: getReferrer(),
  abexpid,
  planId,
});

export default {
  EVENT_NAMES,
  PAGE_NAMES,
  trackEvent,
  trackPageView,
}